import gql from "graphql-tag.macro";

const loadCurrentOrganisationQuery = gql`
    query currentInstance {
        currentInstance {
            ... on Instance {
                _organisation
            }
        }
    }
`;

export const loadCurrentOrganisation = async ({ client }) => {
    const {
        data: {
            currentInstance: {
                _organisation: organisationId,
            },
        },
    } = await client.query({
        query: loadCurrentOrganisationQuery,
    });
    return organisationId;
};
